import React from "react";
import "./Overlay.scss";

const Overlay = () => <div className="overlay"></div>;

export default Overlay;
